import * as React from "react";

export const SvgCheckCircle = (props) => (
	<svg xmlns="http://www.w3.org/2000/svg" width={14} height={15} fill="none" {...props}>
		<path
			fill="#fff"
			d="M6.998 1.525a5.6 5.6 0 1 0 5.6 5.6 5.606 5.606 0 0 0-5.6-5.6Zm2.668 4.62L6.506 9.16a.432.432 0 0 1-.595 0L4.33 7.652a.431.431 0 0 1 .596-.623l1.281 1.223L9.07 5.521a.431.431 0 0 1 .596.623Z"
		/>
	</svg>
);
